<div class="px-3">
  <aipb-simple-card>
    <div class="p-3 border-bottom">
      <span class="text-error text-xl">{{ 'catalog.compare.not_supported_on_mobile' | transloco }}</span>
    </div>

    @if (first) {
      <div class="border-bottom">
        <ng-container *ngTemplateOutlet="view; context: { detail: first }"></ng-container>
      </div>
    }

    @if (second) {
      <div>
        <ng-container *ngTemplateOutlet="view; context: { detail: second }"></ng-container>
      </div>
    }
  </aipb-simple-card>
</div>

<ng-template #view let-detail="detail">
  <cat-header
    (action)="action.emit(detail)"
    [coreId]="detail.coreId"
    [enablePin]="true"
    [header]="detail.document.header"
    [item]="detail.document"
  ></cat-header>
</ng-template>
